export enum ErrorResolutionTypes {
    NONE,
    REDIRECTING,
    WARNING_CODE_MESSAGE,
    GENERIC_MESSAGE,
    ERROR_LIST,
    ERROR_CODE_MESSAGE,
    RE_AUTH,
    MEMBER_NOT_LINKED_ERROR,
    TOO_MANY_REQUESTS,
    EMAIL_CONFLICT,
    ERROR_BOX,
    PARTIAL_SUCCESS,
}

export type ErrorResolution =
    | { type: ErrorResolutionTypes.NONE }
    | { type: ErrorResolutionTypes.REDIRECTING }
    | { type: ErrorResolutionTypes.RE_AUTH }
    | { type: ErrorResolutionTypes.MEMBER_NOT_LINKED_ERROR }
    | { type: ErrorResolutionTypes.ERROR_CODE_MESSAGE; errorMessageId: string; title?: string }
    | { type: ErrorResolutionTypes.WARNING_CODE_MESSAGE; errorCode: string }
    | { type: ErrorResolutionTypes.GENERIC_MESSAGE; errorMessageId?: string }
    | { type: ErrorResolutionTypes.ERROR_LIST; errorMessages: string[]; errorCode: string }
    | { type: ErrorResolutionTypes.TOO_MANY_REQUESTS }
    | { type: ErrorResolutionTypes.EMAIL_CONFLICT }
    | { type: ErrorResolutionTypes.ERROR_BOX; errorCode: string }
    | { type: ErrorResolutionTypes.PARTIAL_SUCCESS };
